import { render, staticRenderFns } from "./MediaNodeConfig.vue?vue&type=template&id=5df248a0&scoped=true"
import script from "./MediaNodeConfig.vue?vue&type=script&lang=js"
export * from "./MediaNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./MediaNodeConfig.vue?vue&type=style&index=0&id=5df248a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df248a0",
  null
  
)

export default component.exports